<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="2" />
    <h4 class="mb-4">Pagos Agrupados por Aseguradora</h4>
    <hr>

    <!-- Botones de período -->
    <div class="mb-3 d-flex flex-wrap gap-2">
      <button class="btn btn-sm btn-outline-primary"   @click="setToday">Hoy</button>
      <button class="btn btn-sm btn-outline-secondary" @click="setThisMonth">Mes Actual</button>
      <button class="btn btn-sm btn-outline-success"   @click="setThisQuarter">Trimestre Actual</button>
      <button class="btn btn-sm btn-outline-info"      @click="setThisSemester">Semestre Actual</button>
      <button class="btn btn-sm btn-outline-warning"   @click="setThisYear">Año Actual</button>
    </div>

    <!-- Rango de fechas -->
    <div class="mb-3">
      <div class="input-group">
        <span class="input-group-text">Desde:</span>
        <input type="date" class="form-control" v-model="fechaDesde">
        <span class="input-group-text">Hasta:</span>
        <input type="date" class="form-control" v-model="fechaHasta">
        <button class="btn btn-dark" @click="fetchPagos" :disabled="cargando">
          <span v-if="cargando" class="spinner-border spinner-border-sm me-1"></span>
          Consultar
        </button>
      </div>
    </div>

    <div v-if="pagosObj.length">
      <!-- Tabs -->
      <div class="tabs">
        <button class="tablink" :class="{ 'active-tab': tabActivo === 'tabla' }"
                @click="tabActivo = 'tabla'">
          <span class="material-symbols-outlined" style="font-size:17px">table_view</span>
          Tabla
        </button>
        <button class="tablink" :class="{ 'active-tab': tabActivo === 'grafico' }"
                @click="tabActivo = 'grafico'">
          <span class="material-symbols-outlined" style="font-size:17px">pie_chart</span>
          Gráfico
        </button>
      </div>

      <!-- Tab Tabla -->
      <div v-if="tabActivo === 'tabla'" class="mt-3">
        <DataTable
          :data="pagosObj"
          :columns="columnas"
          idField="idAsegurador"
          :acciones="false"
          :mostrarBotonTodos="false"
          :mostrarBotonNuevo="false"
          :mostrarBotonExcel="true"
          mensajeVacio="No hay pagos para el período seleccionado."
        >
          <template #cell-asegurador="{ row }">
            <span class="text-primary" style="cursor:pointer"
                  @click="abrirDetalle(row.idAsegurador, row.asegurador, fechaDesde, fechaHasta)"
                  title="Ver detalle">
              {{ row.asegurador }}
            </span>
          </template>
          <template #cell-cantidad="{ row }">
            <span class="d-block text-end">{{ row.cantidad }}</span>
          </template>
          <template #cell-monto="{ row }">
            <span class="d-block text-end">{{ row.monto }}</span>
          </template>
          <template #acciones-extra>
            <div class="col-auto d-flex align-items-center gap-3 ms-2">
              <span class="small fw-bold">Total cantidad: <strong>{{ totalCantidad }}</strong></span>
              <span class="small fw-bold">Total monto: <strong>{{ totalMonto }}</strong></span>
            </div>
          </template>
        </DataTable>
      </div>

      <!-- Tab Gráfico -->
      <div v-if="tabActivo === 'grafico'" class="mt-3">
        <apexchart
          type="pie"
          :options="chartOptions"
          :series="seriesMonto"
          height="420"
        />
      </div>
    </div>

    <div v-else-if="consultado" class="alert alert-info mt-3">
      No hay datos para el período seleccionado.
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout        from '@/components/Layout.vue'
import Footer        from '@/components/Footer.vue'
import DataTable     from '@/components/DataTable.vue'
import VueApexCharts from 'vue3-apexcharts'
import api           from "@/services/api"

export default {
  components: { Layout, Footer, DataTable, apexchart: VueApexCharts },
  data() {
    return {
      fechaDesde:  '',
      fechaHasta:  '',
      pagos:       [],
      tabActivo:   'tabla',
      cargando:    false,
      consultado:  false,
      seriesMonto: [],
    }
  },
  computed: {
    pagosObj() {
      return this.pagos.map(p => ({
        idAsegurador: p[0],
        asegurador:   p[1] || 'Ninguno',
        cantidad:     p[2],
        monto:        p[3],
      }))
    },
    columnas() {
      return [
        {
          field:         'asegurador',
          label:         'Aseguradora',
          filterType:    'select',
          filterOptions: [...new Set(this.pagosObj.map(p => p.asegurador).filter(Boolean))]
                           .sort().map(v => ({ value: v, label: v })),
        },
        { field: 'cantidad', label: 'Cantidad',    numeric: true },
        { field: 'monto',    label: 'Monto Total', numeric: true },
      ]
    },
    totalCantidad() { return this.pagos.reduce((t, p) => t + p[2], 0) },
    totalMonto()    { return this.pagos.reduce((t, p) => t + p[3], 0) },
    chartOptions() {
      return {
        chart:   { type: 'pie', toolbar: { show: false } },
        labels:  this.pagosObj.map(p => p.asegurador),
        tooltip: {
          y: {
            formatter: val => val.toLocaleString('es'),
          },
        },
        legend: { position: 'bottom' },
        responsive: [{
          breakpoint: 480,
          options: { chart: { width: 300 }, legend: { position: 'bottom' } },
        }],
      }
    },
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods: {
    setPeriod(desde, hasta) {
      this.fechaDesde = desde
      this.fechaHasta = hasta
      this.fetchPagos()
    },
    setToday() {
      const t = new Date().toISOString().split('T')[0]
      this.setPeriod(t, t)
    },
    setThisMonth() {
      const d = new Date()
      this.setPeriod(
        new Date(d.getFullYear(), d.getMonth(),     1).toISOString().split('T')[0],
        new Date(d.getFullYear(), d.getMonth() + 1, 0).toISOString().split('T')[0]
      )
    },
    setThisQuarter() {
      const d = new Date(), q = Math.floor(d.getMonth() / 3)
      this.setPeriod(
        new Date(d.getFullYear(), q * 3,     1).toISOString().split('T')[0],
        new Date(d.getFullYear(), q * 3 + 3, 0).toISOString().split('T')[0]
      )
    },
    setThisSemester() {
      const d = new Date(), s = Math.floor(d.getMonth() / 6)
      this.setPeriod(
        new Date(d.getFullYear(), s * 6,     1).toISOString().split('T')[0],
        new Date(d.getFullYear(), s * 6 + 6, 0).toISOString().split('T')[0]
      )
    },
    setThisYear() {
      const y = new Date().getFullYear()
      this.setPeriod(`${y}-01-01`, `${y}-12-31`)
    },
    async fetchPagos() {
      this.cargando   = true
      this.consultado = false
      try {
        const idEmpresa = window.sessionStorage.getItem("idEmpresa")
        const { data }  = await api.get('/vwpagos/agrupados-por-asegurador', {
          params: { idEmpresa, fechaDesde: this.fechaDesde, fechaHasta: this.fechaHasta },
        })
        this.pagos       = data ?? []
        this.seriesMonto = this.pagos.map(p => p[3])
      } catch (e) {
        console.error("Error fetching data:", e)
        this.pagos = []
      } finally {
        this.cargando   = false
        this.consultado = true
      }
    },
    abrirDetalle(idAsegurador, asegurador, fechaDesde, fechaHasta) {
      if (idAsegurador != null) {
        this.$router.push({
          name: 'DetalleAseguradora',
          params: { p_idasegurador: idAsegurador, p_asegurador: asegurador,
                    p_fechadesde: fechaDesde, p_fechahasta: fechaHasta },
        })
      } else {
        this.$router.push({
          name: 'DetalleSinAseguradora',
          params: { p_fechadesde: fechaDesde, p_fechahasta: fechaHasta },
        })
      }
    },
  },
}
</script>

<style scoped>
.tabs {
  display: flex;
  gap: 4px;
  border-bottom: 2px solid #dee2e6;
  margin-bottom: 0;
}
.tablink {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border: none;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  background: transparent;
  color: #6c757d;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  border-radius: 6px 6px 0 0;
  transition: all 0.2s ease;
}
.tablink:hover  { color: #0d6efd; background: #f0f4ff; }
.active-tab     { color: #0d6efd; border-bottom-color: #0d6efd; background: #fff; font-weight: 600; }
</style>